import React, { useState } from 'react';
import BrainSounds from './Components/BrainSounds.js';
import SpiderGraph from './Components/SpiderGraph.js';
import ProgressBar from './Components/ProgressBar.js';
import Calibrate from './Components/Calibrate.js';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import red from '@material-ui/core/colors/red';

import './App.css';
function App() {
  const [muse1, setMuse1] = useState(undefined);
  const [muse2, setMuse2] = useState(undefined);

  return (
    <div className="App">
      <BrainSounds handleMuseConnected = { (m) => setMuse1(m)} handleMuseDisonnected = {() => {console.log('muse disconnected'); setMuse1(undefined)}} muse = {muse1} color = {"primary"} id = {0} />
      <div>
          <Calibrate muse1 = {muse1} muse2 = {muse2} />
          <SpiderGraph muse1 = {muse1} muse2 = {muse2} />
          <ProgressBar muse1 = {muse1} muse2 = {muse2} />
      </div>
      <BrainSounds handleMuseConnected = {(m) => setMuse2(m)} handleMuseDisonnected = {() => setMuse2(undefined)} muse = {muse2} color = {"secondary"}  id = {1} />
    </div>
  );
}

export default App ;
